module.exports = __webpack_public_path__ + "media/images/cover/carport-5fa64d287f24d1c24d222e6fca7185ed.jpg";